"use client"

import { ZoomOut } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ZoomOutIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ZoomOutIcon = component(Icon)({ as: ZoomOut })
